module.exports = __webpack_public_path__ + "img/Icon-Facebook-footer.d3fbe744.svg";